import kr from 'Kr/kr';

export default class ParallaxIt extends kr.Component {
    init() {
        this.movement = this.$element.getAttribute('data-parallax-movement') || 0;
        this.parent = this.$element.parentNode;
        this.event();
    }
    
    event()
    {
        this.parent.addEventListener('mousemove', (event) => {
            this.calc(event);
        })
    }

    calc(e)
    {
        const relX = e.pageX - this.offset(this.parent).left;
        const relY = e.pageY - this.offset(this.parent).top;
        const x = (relX - this.parent.offsetWidth / 2) / this.parent.offsetWidth * this.movement
        const y = (relY - this.parent.offsetHeight / 2) / this.parent.offsetHeight * this.movement
        
        this.$element.style.setProperty('--parallax-x', x+"px");
        this.$element.style.setProperty('--parallax-y', y+"px");
    }

    offset(el) {
        const rect = el.getBoundingClientRect();
        const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
}

kr.registerComponent('.js--parallaxit', {
    component: ParallaxIt
});
